import { render } from "./FRPaymentsReceived.vue?vue&type=template&id=527fc560&scoped=true"
import script from "./FRPaymentsReceived.vue?vue&type=script&lang=js"
export * from "./FRPaymentsReceived.vue?vue&type=script&lang=js"

import "./FRPaymentsReceived.vue?vue&type=style&index=0&id=527fc560&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527fc560"]])

export default __exports__